// Get Reports
export const LOADING_GET_REPORTS = "LOADING_GET_REPORTS";
export const CONFIRMED_GET_REPORTS = "CONFIRMED_GET_REPORTS";
export const FAILED_GET_REPORTS = "FAILED_GET_REPORTS";

// Send Report Link
export const LOADING_SEND_REPORT_LINK = "LOADING_SEND_REPORT_LINK";
export const CONFIRMED_SEND_REPORT_LINK = "CONFIRMED_SEND_REPORT_LINK";
export const FAILED_SEND_REPORT_LINK = "FAILED_SEND_REPORT_LINK";

// Upload Report
export const LOADING_UPLOAD_REPORT = "LOADING_UPLOAD_REPORT";
export const CONFIRMED_UPLOAD_REPORT = "CONFIRMED_UPLOAD_REPORT";
export const FAILED_UPLOAD_REPORT = "FAILED_UPLOAD_REPORT";

export const LOADING_EDIT_REPORT = "LOADING_EDIT_REPORT";
export const CONFIRMED_EDIT_REPORT = "CONFIRMED_EDIT_REPORT";
export const FAILED_EDIT_REPORT = "FAILED_EDIT_REPORT";

export const LOADING_DELETE_REPORT = "LOADING_DELETE_REPORT";
export const CONFIRMED_DELETE_REPORT = "CONFIRMED_DELETE_REPORT";
export const FAILED_DELETE_REPORT = "FAILED_DELETE_REPORT";